export default __webpack_public_path__ + "static/media/Background_00095.cad3edb5.png";